// @flow
import { post } from "./common";
import { handleAPIErrors } from '../sentry-util';


export const submitRating = async(data: Object) => {
  try {
    return await post('/customerRating/setData', data);
  } catch (error) {
    handleAPIErrors(error, '/customerRating/setData', 'POST', data);
    throw error;
  }
};